module.exports = "<!-- Template para las confirmaciones -->\n<ng-template #template>\n  <div class=\"modal-body text-center\">\n    <p>{{ question }}</p>\n    <button type=\"button\" class=\"btn btn-default\" (click)=\"confirm()\">{{ labelConfirm }}</button>\n    <button type=\"button\" class=\"btn btn-primary\" (click)=\"decline()\">{{ labelDecline }}</button>\n  </div>\n</ng-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/confirm/confirm.component.html
// module id = ./src/app/shared/confirm/confirm.component.html
// module chunks = main